export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const GET_USER_SETTINGS_SUCCESS = 'GET_USER_SETTINGS_SUCCESS';
export const GET_USER_SETTINGS_FAILURE = 'GET_USER_SETTINGS_FAILURE';

export const SWITCH_BACK_TO_OLD_VIEW_REQUEST = 'SWITCH_BACK_TO_OLD_VIEW_REQUEST';

export const APP_LOGOUT_REQUEST = 'APP_LOGOUT_REQUEST';

export const APP_READY = 'APP_READY';

export const GET_USER_DARK_MODE_CONFIG = 'GET_USER_DARK_MODE_CONFIG';

export function getLoggedInUser(isAdmin = false, accountKey = '') {
  return {
    type: GET_USER_REQUEST,
    isAdmin,
    accountKey
  };
}
export function triggerLogout() {
  return {
    type: APP_LOGOUT_REQUEST
  };
}

export function switchBackToOldView() {
  return {
    type: SWITCH_BACK_TO_OLD_VIEW_REQUEST
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/User/UserActions.js